import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import MainRoutes from './MainRoutes';
import AuthRoutes from './AuthRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const NotFound = Loadable(lazy(() => import('pages/status/NotFound')));
const AccountBlocked = Loadable(lazy(() => import('pages/status/AccountBlocked')));

const router = createBrowserRouter(
  [
    MainRoutes,
    AuthRoutes,
    {
      path: '/account-blocked',
      element: <AccountBlocked />
    },
    {
      path: '*',
      element: <NotFound />
    }
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
